import { render, staticRenderFns } from "./kdxHeaderBar.g.vue?vue&type=template&id=0c3e339f&scoped=true"
import script from "./kdxHeaderBar.g.vue?vue&type=script&lang=js"
export * from "./kdxHeaderBar.g.vue?vue&type=script&lang=js"
import style0 from "./kdxHeaderBar.g.vue?vue&type=style&index=0&id=0c3e339f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3e339f",
  null
  
)

export default component.exports